module.exports = __webpack_public_path__ + "static/office-2dc13ecf36e6edcd80e70eba03fad8ee.jpg";